import el from '@finn-no/create-element';
import ModalOverlay from '../lib/ModalOverlay.js';

// TODO: styling for bigger screens

export default {
    dependencies: ['$element'],
    callable(ele) {
        const button = ele.querySelector('[data-share-button]');
        button.addEventListener('click', openShareSheet);
        let shareItems;

        function openShareSheet() {
            if (!shareItems) {
                shareItems = ele.querySelector('[data-share-items]');
                shareItems.style.display = '';
            }

            const shareSheet = new ModalOverlay(
                'Del annonsen',
                el(
                    'div.u-ma16',
                    { style: 'margin-bottom: 40px !important;' },
                    el(
                        'div.flex.justify-space-between',
                        null,
                        el('h2.u-stone.u-mb0', null, 'Del annonsen'),
                        el(
                            'button.button.button--flat.u-pa0',
                            {
                                onclick() {
                                    shareSheet.dismiss('cancel');
                                },
                            },
                            el(
                                'svg:svg.u-valign-middle',
                                {
                                    width: '18',
                                    height: '18',
                                    viewBox: '0 0 18 18',
                                },
                                el('svg:path', {
                                    stroke: '#767676',
                                    'stroke-width': '3',
                                    d: 'M2 2l14 14M16 2L2 16',
                                })
                            )
                        )
                    ),
                    shareItems
                ),
                {
                    slide: true,
                    size: {
                        top: 'auto',
                    },
                }
            );
            shareSheet.show();
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/shareAd.js